import { useQuery } from '@tanstack/react-query'

import { getLastMindsetApi, getMyReportsApi, getReportDetailApi } from '@/api/reportApi'

export const useGetMyReports = () => {
  return useQuery({
    queryKey: ['myReports'],
    queryFn: getMyReportsApi,
    retry: false
  })
}

// 내 상담리포트 중에 unread 가 하나라도 있는지 여부
export const useHasUnreadMyReports = () => {
  return useQuery({
    queryKey: ['myReports'],
    queryFn: getMyReportsApi,
    select: data => data.reports?.some(report => !report.is_read) ?? false
  })
}

export const useGetReportDetail = (report_id: number) => {
  return useQuery({
    queryKey: ['reportDetail', report_id],
    queryFn: () => getReportDetailApi(report_id),
    retry: false,
    enabled: !!report_id
  })
}

export const useGetLastMindset = () => {
  return useQuery({
    queryKey: ['lastMindset'],
    queryFn: () => getLastMindsetApi(),
    retry: false
  })
}
